import { createContext } from "react";

const AddPropertyContext = createContext();

export default AddPropertyContext;
